// src/components/CustomNestedMenu.js
import { useState, createElement } from 'react';
import { useSelector } from 'react-redux';
import { MenuItemLink, getResources } from 'react-admin';
import { List, ListItem, ListItemText, Collapse } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import { ExpandLess, ExpandMore } from '@material-ui/icons';

import DevicesIcon from '@material-ui/icons/DevicesOther';
import VideoCallIcon from '@material-ui/icons/Videocam';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';

import { withRouter } from 'react-router-dom';
import image from '../assets/image/VERA.png';

const CustomNestedMenu = ({ onMenuClick }) => {

    const [openDevices, setOpenDevices] = useState(false);
    const [openVideoCalls, setOpenVideoCalls] = useState(false);
    const [openUsers, setOpenUsers] = useState(false);

    const sidebarOpen = useSelector(state => state.admin.ui.sidebarOpen);
    const resources = useSelector(getResources) || [];

    const usersFilter = ['users', 'professional', 'admins', 'superAdmins'];
    const devicesFilter = ['installations', 'devices', 'comunicationDevices', 'cameraDevices'];
    const devicesSubmenu = ['installations', 'comunicationDevices'];
    const videoSubmenu = ['devices', 'cameraDevices'];

    const usersResources = resources.filter(r => usersFilter.includes(r.name));
    const nonUsers = resources.filter(r => !usersFilter.includes(r.name));

    const idxActivities = nonUsers.findIndex(r => r.name === 'activities');

    const beforeActivities = idxActivities >= 0 ? nonUsers.slice(0, idxActivities) : [];
    const afterActivities = idxActivities >= 0 ? nonUsers.slice(idxActivities + 1) : [];

    const activitiesResource = idxActivities >= 0 ? nonUsers[idxActivities] : null;

    return (
        <>
            <img
                src={image}
                alt="logo"
                height={45}
                style={{ objectFit: 'contain', marginTop: 10 }}
            />

            <List>

                {/* --- 1. RECURSOS ANTES DE ACTIVITIES --- */}
                {beforeActivities.map(resource =>
                    resource.hasList && (
                        <Tooltip
                            title={(resource.options?.label) || resource.name}
                            placement="right"
                            key={resource.name}
                        >
                            <span>
                                <MenuItemLink
                                    to={`/${resource.name}`}
                                    primaryText={(resource.options?.label) || resource.name}
                                    leftIcon={resource.icon && createElement(resource.icon)}
                                    onClick={onMenuClick}
                                    sidebarIsOpen={sidebarOpen}
                                />
                            </span>
                        </Tooltip>
                    )
                )}

                {/* --- 2. GESTIÓN DE USUARIOS (justo antes de actividades) --- */}
                {usersResources.length > 0 && (
                    <>
                        <Tooltip title="Gestión de Usuarios" placement="right">
                            <ListItem
                                button
                                onClick={() => setOpenUsers(!openUsers)}
                                style={{ color: 'rgba(0, 0, 0, 0.54)' }}
                            >
                                <SupervisorAccountIcon />
                                {sidebarOpen && (
                                    <>
                                        <ListItemText primary="Gestión de Usuarios" style={{ marginLeft: '1rem' }} />
                                        {openUsers ? <ExpandLess /> : <ExpandMore />}
                                    </>
                                )}
                            </ListItem>
                        </Tooltip>

                        <Collapse in={openUsers} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding style={{ paddingLeft: 38 }}>
                                {usersResources.map(resource => (
                                    resource.hasList && (
                                        <Tooltip
                                            title={(resource.options?.label) || resource.name}
                                            placement="right"
                                            key={resource.name}
                                        >
                                            <span>
                                                <MenuItemLink
                                                    to={`/${resource.name}`}
                                                    primaryText={(resource.options?.label) || resource.name}
                                                    leftIcon={resource.icon && createElement(resource.icon)}
                                                    onClick={onMenuClick}
                                                    sidebarIsOpen={sidebarOpen}
                                                />
                                            </span>
                                        </Tooltip>
                                    )
                                ))}
                            </List>
                        </Collapse>
                    </>
                )}

                {/* --- 3. ACTIVIDADES (si existe) --- */}
                {activitiesResource && activitiesResource.hasList && (
                    <Tooltip
                        title={(activitiesResource.options?.label) || activitiesResource.name}
                        placement="right"
                        key="activities"
                    >
                        <span>
                            <MenuItemLink
                                to="/activities"
                                primaryText={(activitiesResource.options?.label) || activitiesResource.name}
                                leftIcon={activitiesResource.icon && createElement(activitiesResource.icon)}
                                onClick={onMenuClick}
                                sidebarIsOpen={sidebarOpen}
                            />
                        </span>
                    </Tooltip>
                )}

                {/* --- 4. DISPOSITIVOS (justo después de actividades) --- */}
                {resources.some(r => devicesFilter.includes(r.name) && r.hasList) && (
                    <>
                        <Tooltip title="Dispositivos" placement="right">
                            <ListItem
                                button
                                onClick={() => setOpenDevices(!openDevices)}
                                style={{ color: 'rgba(0, 0, 0, 0.54)' }}
                            >
                                <DevicesIcon />
                                {sidebarOpen && (
                                    <>
                                        <ListItemText primary="Dispositivos" style={{ marginLeft: '1rem' }} />
                                        {openDevices ? <ExpandLess /> : <ExpandMore />}
                                    </>
                                )}
                            </ListItem>
                        </Tooltip>

                        <Collapse in={openDevices} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding style={{ paddingLeft: 38 }}>

                                {resources
                                    .filter(r => devicesSubmenu.includes(r.name))
                                    .map(resource =>
                                        resource.hasList && (
                                            <Tooltip
                                                title={(resource.options?.label) || resource.name}
                                                placement="right"
                                                key={resource.name}
                                            >
                                                <span>
                                                    <MenuItemLink
                                                        to={`/${resource.name}`}
                                                        primaryText={(resource.options?.label) || resource.name}
                                                        leftIcon={resource.icon && createElement(resource.icon)}
                                                        onClick={onMenuClick}
                                                        sidebarIsOpen={sidebarOpen}
                                                    />
                                                </span>
                                            </Tooltip>
                                        )
                                    )}

                                {/* Videollamadas */}
                                {resources.some(r => videoSubmenu.includes(r.name) && r.hasList) && (
                                    <>
                                        <Tooltip title="Videollamadas" placement="right">
                                            <ListItem
                                                button
                                                onClick={() => setOpenVideoCalls(!openVideoCalls)}
                                                style={{ color: 'rgba(0, 0, 0, 0.54)' }}
                                            >
                                                <VideoCallIcon />
                                                {sidebarOpen && (
                                                    <>
                                                        <ListItemText primary="Videollamadas" style={{ marginLeft: '1rem' }} />
                                                        {openVideoCalls ? <ExpandLess /> : <ExpandMore />}
                                                    </>
                                                )}
                                            </ListItem>
                                        </Tooltip>

                                        <Collapse in={openVideoCalls} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding style={{ paddingLeft: 32 }}>
                                                {resources
                                                    .filter(r => videoSubmenu.includes(r.name))
                                                    .map(resource =>
                                                        resource.hasList && (
                                                            <Tooltip
                                                                title={(resource.options?.label) || resource.name}
                                                                placement="right"
                                                                key={resource.name}
                                                            >
                                                                <span>
                                                                    <MenuItemLink
                                                                        to={`/${resource.name}`}
                                                                        primaryText={(resource.options?.label) || resource.name}
                                                                        leftIcon={resource.icon && createElement(resource.icon)}
                                                                        onClick={onMenuClick}
                                                                        sidebarIsOpen={sidebarOpen}
                                                                    />
                                                                </span>
                                                            </Tooltip>
                                                        )
                                                    )}
                                            </List>
                                        </Collapse>
                                    </>
                                )}
                            </List>
                        </Collapse>
                    </>
                )}

                {/* --- 5. RESTO DE MENÚ DESPUÉS DE DISPOSITIVOS --- */}
                {afterActivities.map(resource =>
                    resource.hasList &&
                    !devicesFilter.includes(resource.name) && (
                        <Tooltip
                            title={(resource.options?.label) || resource.name}
                            placement="right"
                            key={resource.name}
                        >
                            <span>
                                <MenuItemLink
                                    to={`/${resource.name}`}
                                    primaryText={(resource.options?.label) || resource.name}
                                    leftIcon={resource.icon && createElement(resource.icon)}
                                    onClick={onMenuClick}
                                    sidebarIsOpen={sidebarOpen}
                                />
                            </span>
                        </Tooltip>
                    )
                )}

            </List>
        </>
    );
};

export default withRouter(CustomNestedMenu);